import { getProp } from "../ParsedSummary";
import { collaborationLevelDescriptions } from "./questionBreakdown";

export const executiveSummary = (summary, sections) => {
  const executiveSummary = getProp(summary, ['executive', 'summary', 'group']);
  if (executiveSummary) {
    const title = getProp(executiveSummary, 'title');
    sections.push({
      type: 'title-main',
      content: title || 'Group Executive Summary'
    });

    // Standard
    const standard = getProp(executiveSummary, ['standard', 'math_area', 'area']);
    if (standard && typeof standard === 'string') {
      sections.push({
        type: 'bullet',
        label: 'Standard:',
        content: standard
      });
    }

    // Overview (if exists)
    const overview = getProp(executiveSummary, ['overview', 'session']);
    if (overview && typeof overview === 'string') {
      sections.push({
        type: 'bullet',
        label: 'Overview:',
        content: overview
      });
    }

    // Key Outcomes (if exists)
    const keyOutcomes = getProp(executiveSummary, ['key_outcome', 'outcome']);
    if (keyOutcomes && typeof keyOutcomes === 'string') {
      sections.push({
        type: 'bullet',
        label: 'Key Outcomes:',
        content: keyOutcomes
      });
    }

    // Overall Math Learning
    const mathLearning = getProp(executiveSummary, ['mathLearning', 'math_learning', 'learning']);
    if (mathLearning) {
      const label = getProp(mathLearning, 'label');
      sections.push({
        type: 'bullet',
        content: label || 'Overall Math Learning'
      });

      const category = getProp(mathLearning, 'category');
      if (category && typeof category === 'string') {
        sections.push({
          type: 'sub-bullet',
          label: 'Level:',
          content: category
        });
      }

      const rationale = getProp(mathLearning, 'rationale');
      if (rationale && typeof rationale === 'string') {
        sections.push({
          type: 'sub-bullet',
          label: 'Rationale:',
          content: rationale
        });
      }

      const colorCode = getProp(mathLearning, ['color', 'code']);
      if (colorCode && typeof colorCode === 'string') {
        sections.push({
          type: 'sub-bullet',
          content: colorCode
        });
      }
    }

    // Overall Math Discourse & Collaboration
    const collaboration = getProp(executiveSummary, ['collaboration', 'group_collaboration']);
    if (collaboration) {
      const label = getProp(collaboration, 'label');
      sections.push({
        type: 'bullet',
        content: label || 'Overall Math Discourse & Collaboration'
      });

      const level = getProp(collaboration, ['level', 'category']);
      if (level && typeof level === 'string') {
        const levelNum = String(level).match(/\d+/)?.[0];
        sections.push({
          type: 'sub-bullet',
          label: 'Level:',
          content: level,
          tooltip: levelNum ? collaborationLevelDescriptions[levelNum] : undefined
        });
      }

      const collabRationale = getProp(collaboration, 'rationale');
      if (collabRationale && typeof collabRationale === 'string') {
        sections.push({
          type: 'sub-bullet',
          label: 'Rationale:',
          content: collabRationale
        });
      }

      const highlight = getProp(collaboration, 'highlight');
      if (highlight && typeof highlight === 'string') {
        sections.push({
          type: 'sub-bullet',
          label: 'Highlight:',
          content: highlight
        });
      }

      const colorCode = getProp(collaboration, ['color', 'code']);
      if (colorCode && typeof colorCode === 'string') {
        sections.push({
          type: 'sub-bullet',
          content: colorCode
        });
      }

      const groupSizeWarning = getProp(collaboration, ['groupSizeWarning', 'warning']);
      if (groupSizeWarning && typeof groupSizeWarning === 'string') {
        sections.push({
          type: 'warning',
          content: groupSizeWarning
        });
      }
    }

    // Recommendations (if exists)
    const recommendations = getProp(executiveSummary, ['recommendation', 'recommendations']);
    if (recommendations && Array.isArray(recommendations) && recommendations.length > 0) {
      sections.push({
        type: 'bullet',
        content: 'Recommendations'
      });

      recommendations.forEach(rec => {
        const recommendation = typeof rec === 'string' ? rec : getProp(rec, 'recommendation');
        const evidence = getProp(rec, 'evidence');

        if (recommendation && typeof recommendation === 'string') {
          sections.push({
            type: 'sub-bullet',
            content: recommendation
          });
        }
        if (evidence && typeof evidence === 'string') {
          sections.push({
            type: 'sub-sub-bullet',
            label: 'Evidence:',
            content: evidence
          });
        }
      });
    }
  }
}
